import React from 'react'
import { CreateTableState, List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import { budgetConfig } from 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/subcomponents/ModifyList/configs/budgetTableConfig'

const BudgetsList = ({ updateRow, rows, resource, EmptyComponent }) => {
  const tableConfig = budgetConfig({
    updateRow,
    resource,
  })
  const tableState = CreateTableState(tableConfig, rows)

  return (
    <List
      config={tableConfig}
      table={tableState}
      EmptyComponent={EmptyComponent}
    />
  )
}

export default BudgetsList

BudgetsList.propTypes = {
  updateRow: PropTypes.func,
  rows: PropTypes.array,
  resource: PropTypes.string,
  EmptyComponent: PropTypes.elementType,
}
